import { registerLocaleData } from '@angular/common';
import LocaleFr from '@angular/common/locales/fr';
import { NgModule, Type } from '@angular/core';
import { ContactAddressPipe } from './contactAddress.pipe';
import { ContactNamePipe } from './contactName.pipe';
import { DateWithLocalePipe } from './dateWithLocale.pipe';
import { ContactPipe, IContactPipe } from './icontact.pipe';
import { IsDatePipe } from './isDate.pipe';
import { PriceFormatPipe } from './priceFormat.pipe';
import { ReversePipe } from './reverse.pipe';
import { TimetablePipe } from './timetable.pipe';

const pipes: Type<any>[] = [
	DateWithLocalePipe,
	PriceFormatPipe,
	IsDatePipe,
	IContactPipe,
	ContactPipe,
	ContactAddressPipe,
	ContactNamePipe,
	TimetablePipe,
	ReversePipe,
];

@NgModule({
	imports: [],
	exports: pipes,
	declarations: pipes,
	providers: pipes
})
export class PipeModule {
	constructor() {
		registerLocaleData(LocaleFr);
	}
}
